import isDefined from "./isDefined";

var getDisplay = function getDisplay(inline) {
  return isDefined(inline) && (inline ? "inline-flex" : "flex");
};

export default getDisplay;